module.exports = __webpack_public_path__ + "img/sportsforecaster_logo.6a319661.png";